import { ScrollArea }                      from "@mantine/core";
import { useScrollIntoView }               from "@mantine/hooks";
import dynamic                             from "next/dynamic";
import { useRouter }                       from "next/router";
import { forwardRef, useImperativeHandle } from "react";

import { useGetDeviceType } from "_common/hooks/global";
import { isPageRoute }      from "_common/utils";
import Render               from "_components/atoms/render";

import useStyles from "./styles";

const ChatMode             = dynamic ( () => import ( "_components/features/chat/chatMode" ) );
const UserPopOver          = dynamic ( () => import ( "_components/features/chat/userPopOver" ) );
const EmptyChatMessageView = dynamic ( () => import ( "_components/atoms/EmptyMessageChatView" ) );
const RenderComments       = dynamic ( () => import ( "./renderComments" ) );

const component = forwardRef ( ( props, ref ) => {
	const {
		comments,
		emotesList,
		isStreamer,
		handleDropDownPopup,
		handleCloseDropDownPopup,
		openDropDownPopup,
		isPopUpOpen,
		muteUser,
		pinComment,
		userProfile,
		popOverState,
		banOptionsPopUpState,
		currentlySelectedUser,
		autoScrollEnabled,
		selectedComment,
		streamerName,
		handleChatTips,
		userId,
		isFollowingUser,
		blockUser,
		deleteComment,
		isModerator,
		isStreamerComment,
		isBlockedByStreamer,
		isLive,
		togglePolls,
		handleModal,
		chatPoppedOut,
		onScroll
	} = props;

	const { classes, cx } = useStyles ( { isStreamer, chatPoppedOut } );

	const router       = useRouter ();
	const isStudioPage = isPageRoute ( { router, page: "studio" } );

	const deviceType       = useGetDeviceType ();
	const isMobile         = chatPoppedOut ? false : deviceType === "mobile";
	const isMobileOrTablet = chatPoppedOut ? false : isMobile || deviceType === "tablet";

	const {
		scrollIntoView,
		targetRef,
		scrollableRef
	} = useScrollIntoView ( {
		duration : 100,
		easing   : t => t
	} );

	useImperativeHandle ( ref, () => ( {
		chatArea: scrollableRef?.current,
		scrollIntoView
	} ) );

	/*
   * If no comments in array
   */
	if ( !comments?.length || isBlockedByStreamer ) {
		return (
			<>
				<Render condition = { isStudioPage }>
					<ChatMode disabled = { !isLive } />
				</Render>

				<div className = { cx ( classes.parent, classes.followerChatParent ) }>
					<EmptyChatMessageView
						msg = {
							isBlockedByStreamer
								? "Live chat not available"
								: isStreamer
									? "Your chats and live interactions will appear here."
									: "Be the first one to comment"
						}
					/>
				</div>
			</>
		);
	}

	return (
		<>
			<Render condition = { isStreamer && !chatPoppedOut }>
				<ChatMode />
			</Render>

			<ScrollArea
				className = { classes.parent }
				onScrollPositionChange = { onScroll }
				style = { { paddingTop: isStreamer ? "65px" : "0px" } }
				viewportRef = { scrollableRef }
			>

				{
					comments?.map ( comment => {
						return (
							<RenderComments
								key = { comment?.uniqueID }
								autoScrollEnabled = { autoScrollEnabled }
								comment = { comment }
								emotesList = { emotesList }
								handleChatTips = { handleChatTips }
								handleDropDownPopup = { handleDropDownPopup }
								handleModal = { handleModal }
								isFollowingUser = { isFollowingUser }
								isModerator = { isModerator }
								isPopUpOpen = { isPopUpOpen }
								isStreamer = { isStreamer }
								selectedComment = { selectedComment }
								streamerName = { streamerName }
								togglePolls = { togglePolls }
								userId = { userId }
								userPopover = { currentlySelectedUser != null && !isMobileOrTablet && (
									<UserPopOver
										banOptionsPopUpState = { banOptionsPopUpState }
										blockUser = { blockUser }
										currentUser = { currentlySelectedUser }
										deleteComment = { deleteComment }
										handleClose = { handleCloseDropDownPopup }
										handleDropDownPopup = { handleDropDownPopup }
										isModerator = { isModerator }
										isPopUpOpen = { isPopUpOpen }
										isStreamer = { isStreamer }
										isStreamerComment = { isStreamerComment }
										muteUser = { muteUser }
										openDropDownPopup = { openDropDownPopup }
										pinComment = { pinComment }
										popOverState = { popOverState }
									/>
								) }
								userProfile = { userProfile }
							/>
						);
					} )
				}

				<div ref = { targetRef }></div>

			</ScrollArea>

		</>
	);
} );

component.displayName = "component";
export default component;

/*
 * DO NOT DELETE
    we will need a check in future to distinguish between chatTip comment and special comment (squadplay)
  */
// const checkSpecialComment = (comment) =>  {
// comment.chatTip ? renderChatTip(comment): getSpecialComment(comment);
// };

/* const getSpecialComment = (comment) => {
*  // This is used in case of squad play
*  // Update this code when this feature becomes active again
 *     return (
 *         <div
 * className = { classes.specialComment }
 * key       = { comment?.id }
 *         >
 * <div className  = "flex alignItemsCenter">
 * <StarIcon style = { { height: "30px", width: "30px" } } />
 *             </div>
 * <span style     = { { paddingLeft: "5px", flex: 1 } }>
 * <span className = "fontBold">
 *                     { comment?.commentText }
 *                 </span>
 *                 {
 *                     comment?.type === "JOINING_SESSION" ? (
 *                         <>
 *                             <br />
 *                             <span
 *                                 style = { {
 * color: "#126bd5"
 *                                 } }
 *                             >
 *                                 Use Rooter Android App for joining.
 *                             </span>
 *                         </>
 *                     ) : null
 *                 }
 *             </span>
 *         </div>
 *     );
 * }; */
